var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccord2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.839,
    height: 636.225,
    viewBox: "0 0 194.839 636.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "accord_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655.864,362.386a466.561,466.561,0,0,0,9.794,50.361c5,19.543,7.839,39.551,10.054,59.577,1.474,13.327,3.629,26.755,3.778,40.18,0.439,39.432-.3,78.923-0.169,118.374l0.01,3.078s-1.085,24.591-3.238,23.139",
    transform: "translate(-628.284 -44.76)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M820.1,375.416s-35.453,48.435-38.821,114.12L762.245,657.157",
    transform: "translate(-628.284 -44.76)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M694.77,57.492c-3.852-2.723-34.587,13.1-34.587,13.1l35.117,1.26c42.189,5.3,64.168,28.042,64.168,28.042,9.1,12.126,22.989,20.968,22.989,20.968,24.758,13.39,28.969,119.327,29.053,124.632s7.326,15.326,7.326,15.326c3.621,1.347,3.537-3.031,3.537-3.031-0.5-24.758-6.063-169.769-6.063-169.769-1.01-19.7-24.253-27.284-24.253-27.284l-3.683-.8",
    transform: "translate(-628.284 -44.76)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.921,
    cy: 11.142,
    rx: 49.006,
    ry: 10.392,
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M660.183,70.589s-26.1,11.368-28.126,44.716l-1.685,58.1-1.263,40.042V302.5l2.779,37.895,5.81,34.861c2.8,16.77,7.365,33.16,9.159,50.1,4.817,45.475,5.366,91.316,6.006,137l0.752,53.657s-2.527,25.768,6.568,30.063l14.9,10.358s19.958,12.884,23.242,17.179c0,0,21.474,14.9,42.442,0,0,0,63.158-45.727,66.19-63.411,0,0,3.031-11.116,3.789-32.337L820.1,375.416l2.273-100.7c0-5.332-.687-10.26-4.05-14.615",
    transform: "translate(-628.284 -44.76)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M629.109,241.452l5.642,74.273c1.516,22.4,8.421,32.337,8.422,32.338,3.249,6.266,7.957,12.835,14.888,15.3,13.472,4.794,18.349-7.213,22.01-17.481,2.875-8.066,5.35-16.3,7.558-24.574,4.936-18.5,10.563-37.572,13.453-56.472,2.909-19.024,3.339-38.316,3.243-57.529-0.045-9.047-.486-18.159-0.468-27.17,0.018-9.107.881-18.431-3.725-26.672a42.228,42.228,0,0,0-14.25-14.7,61.251,61.251,0,0,0-22.836-8.98c-6.978-2.047-15.921-3.8-22.666.008-5.242,2.958-5.69,8.771-6.11,14.117-1.347,11.278-1.146,22.88-1.756,34.223l-2.705,50.306C629.583,232.65,628.789,237.24,629.109,241.452Z",
    transform: "translate(-628.284 -44.76)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M638.261,174.042c0.672-3.169,2.162-5.85,5.811-5.07,11.02,2.356,21.874,6.5,32.744,9.538a14.124,14.124,0,0,1,4.063,1.606c2.5,1.655,2.727,4.58,2.716,7.311-0.047,11.826.012,23.64,0.106,35.467,0.042,5.275-1.21,10.848-7.644,10.8a20.777,20.777,0,0,1-6.779-1.6c-6.845-2.461-13.673-4.975-20.423-7.686-5.866-2.356-12.062-4.379-12.529-11.749-0.679-10.741.554-21.954,1.293-32.67A43.08,43.08,0,0,1,638.261,174.042Z",
    transform: "translate(-628.284 -44.76)",
    fill: "none",
    stroke: "#54b0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 657.818,
    cy: 341.351,
    rx: 12.037,
    ry: 15.923,
    transform: "translate(-688.772 114.158) rotate(-13.175)",
    fill: "none",
    stroke: "#54b0ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord2);
export default __webpack_public_path__ + "static/media/accord_2.760225425110308a759622eb32354c28.svg";
export { ForwardRef as ReactComponent };